import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dv-smartMeter",
  "use": "dv-smartMeter-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"dv-smartMeter\"><defs><style>#dv-smartMeter .cls-1{fill:#fff1de;fill-opacity:0}</style></defs><title>资源 3</title><g id=\"dv-smartMeter_图层_2\" data-name=\"图层 2\"><g id=\"dv-smartMeter_图层_1-2\" data-name=\"图层 1\"><path id=\"dv-smartMeter_矩形_268\" data-name=\"矩形 268\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><path id=\"dv-smartMeter_路径_1244\" data-name=\"路径 1244\" d=\"M20.89 1.5H3.65a1 1 0 0 0-1 1v19a1 1 0 0 0 1 1h17.24a1 1 0 0 0 1-1v-19a1 1 0 0 0-1-1zm-6.68 13.93c-1 1.32-2 2.63-3.05 3.95-.08.1-.17.21-.3.13s0-.22 0-.32c.31-.84.61-1.68.94-2.52.11-.28.05-.38-.26-.37a4.39 4.39 0 0 1-.81 0c-.31-.05-.46-.22-.34-.55.4-1.06.8-2.13 1.21-3.19.17-.44.57-.22.83-.28h.31c.6 0 .7.15.48.73l-.48 1.27c-.2.55-.19.55.37.55h.82c.42 0 .55.28.3.61zm4.89-7.17a1 1 0 0 1-1 1H6.42a1 1 0 0 1-1-1V4.58a1 1 0 0 1 1-1h11.7a1 1 0 0 1 1 1z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/dv-smartMeter.svg
// module id = ujVB
// module chunks = 6